import React from 'react';
import { Layout } from 'antd';
import SiteFooter from './SiteFooter';

const { Footer } = Layout;

/** Shared footer for every authenticated page — same content everywhere, per the shared-chrome mockups. */
const AppFooter: React.FC = () => {
  return (
    <Footer>
      <SiteFooter />
    </Footer>
  );
};

export default AppFooter;
